import {
  MemberPersonalDetails,
  MemberAssignments,
  MemberNotifications
} from '@/components/MemberSettings'
import type { TabType } from './types'

const OrganizationMemberTabs: TabType[] = [
  {
    url: 'details',
    label: 'Personal Details',
    component: MemberPersonalDetails,
  },
  {
    url: 'assignments',
    label: 'Assignments',
    component: MemberAssignments,
  },
  {
    url: 'notifications',
    label: 'Notifications',
    component: MemberNotifications,
  },
]

export default OrganizationMemberTabs
